import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import TrailDashboard from '../TrailDashboard';
// import WCATemplateLibrary from '../WCA/WCAMessageTemplate/TemplateLibrary';
import WCATemplateLibrary from '../WCA/WCAMessageTemplate/TemplateLibrary';

const TemplateLibrary = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);

  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return companyConfigData?.wabaPartner === 'skalebot' ? (
    <WCATemplateLibrary />
  ) : (
    <Navigate to="/campaign-templates/list" replace />
  );
};

export default TemplateLibrary;
